import { render, staticRenderFns } from "./ExternalOrdersImport.vue?vue&type=template&id=5d1ae2b8&scoped=true"
import script from "./ExternalOrdersImport.vue?vue&type=script&lang=js"
export * from "./ExternalOrdersImport.vue?vue&type=script&lang=js"
import style0 from "./ExternalOrdersImport.vue?vue&type=style&index=0&id=5d1ae2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ae2b8",
  null
  
)

export default component.exports